import {Component} from '@angular/core';
import {TranslationService} from '../../services/translation.service';
import {LoginService} from '../login/login.service';

/**
 * Info-Seite für SSO-Gast-Accounts: erklärt einheitlich, dass die gewünschte Aktion mit einem
 * Gast-Zugang nicht möglich ist, und bietet das Abmelden an. Angesteuert vom
 * `GuestAccountInterceptor` und vom `GuestAccountGuard`.
 *
 * Die Komponente ist im `AppModule` deklariert (Angular 15, keine Standalone-Komponenten in dieser
 * Linie); `ApplyIfNotEmptyDirective` und `MatButtonModule` kommen von dort.
 */
@Component({
  selector: 'app-guest-user-information',
  templateUrl: './guest-user-information.component.html',
  styleUrls: ['./guest-user-information.component.css']
})
export class GuestUserInformationComponent {
  // Fallback, solange der Key noch nicht in HUP_CFG_Translations steht: getTranslation liefert für
  // unbekannte Keys einen Leerstring - der Nutzer stünde sonst vor einer leeren Seite.
  private static readonly DEFAULT_MESSAGE =
    'Diese Aktion ist mit einem Gast-Zugang nicht möglich. Bitte melden Sie sich mit Ihrem persönlichen Konto an.';

  constructor(
    public translationService: TranslationService,
    private loginService: LoginService
  ) {
  }

  get message(): string {
    const translation = this.translationService.getTranslation('guestUser.informationMessage');
    return translation?.trim() ? translation : GuestUserInformationComponent.DEFAULT_MESSAGE;
  }

  logout(): void {
    this.loginService.logout();
  }
}
